export const THRESHOLD = 140;
export const MAX_PULL = 200;
export const RESISTANCE = 0.5;
